import { SvgIcon, SvgIconProps } from '@mui/material';

function GroupsSVG(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path
        d="M4.50033 1.5H11.5003C12.5128 1.5 13.3337 2.32081 13.3337 3.33333V16.8333H2.66699V3.33333C2.66699 2.32081 3.4878 1.5 4.50033 1.5Z"
        stroke="#0173C8"
      />
      <rect
        x="0.5"
        y="-0.5"
        width="13"
        height="2.5"
        transform="matrix(1 0 0 -1 1 18.8999)"
        stroke="#0173C8"
      />
      <path
        d="M5.66667 3.83325H10.3333C10.7015 3.83325 11 4.13173 11 4.49992V6.33325H5V4.49992C5 4.13173 5.29848 3.83325 5.66667 3.83325Z"
        stroke="#0173C8"
      />
      <path
        d="M9.15107 8L6.0166 12.172H7.64072L6.9961 14.8783L10.1306 10.7063H8.50684L9.15107 8Z"
        fill="#0173C8"
      />
      <path d="M13 13.8303C14.75 13.8697 18.8333 13.5971 18.8333 10.3335" stroke="#0173C8" />
      <rect x="17.7998" y="7.30005" width="2" height="3" stroke="#0173C8" />
    </SvgIcon>
  );
}

export default GroupsSVG;
